import { render, staticRenderFns } from "./UITable.vue?vue&type=template&id=fb2e48a2&scoped=true&"
import script from "./UITable.vue?vue&type=script&lang=js&"
export * from "./UITable.vue?vue&type=script&lang=js&"
import style0 from "./UITable.vue?vue&type=style&index=0&id=fb2e48a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2e48a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2e48a2')) {
      api.createRecord('fb2e48a2', component.options)
    } else {
      api.reload('fb2e48a2', component.options)
    }
    module.hot.accept("./UITable.vue?vue&type=template&id=fb2e48a2&scoped=true&", function () {
      api.rerender('fb2e48a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UITable.vue"
export default component.exports